<div class="dialog-content-wrapper">
  <!-- <div class="head">
    <button mat-icon-button mat-dialog-close class="close" (click)="matDialogRef.close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div> -->

  <mat-carousel
    timings="250ms ease-in"
    [autoplay]="false"
    interval="5000"
    color="accent"
    maxWidth="100%"
    maxHight="50%"
    proportion="25"
    slides="5"
    [loop]="false"
    [hideArrows]="false"
    [hideIndicators]="true"
    [useKeyboard]="true"
    [useMouseWheel]="false"
    orientation="ltr"
    class="matCarousel"
  >
    <mat-carousel-slide
      #matCarouselSlide
      *ngFor="let slide of images; let i = index"
      overlayColor="#00000040"
      [hideOverlay]="false"
      style="text-align: center"
    >
      <div
        style="
          width: 100%;
          text-align: center;
          height: 100%;
          background-color: black;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <div style="max-width: 100%; max-height: 100%">
          <img style="max-width: 100%; max-height: 100%" src="{{ slide }}" />
        </div>
      </div>
    </mat-carousel-slide>
  </mat-carousel>
  <div style="position: absolute">
    <button
      mat-icon-button
      mat-dialog-close
      class="close"
      (click)="matDialogRef.close()"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
